<ndt-add-schedule-hour-view
   [callState]="callState | async"
   [form]="form"
   [title]="title"
   [isAdd]="isAdd"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-schedule-hour-view>
